import { Preferences } from "@capacitor/preferences";
import { BACKGROUND_GEOLOCATION_TRACKING_SETTING_KEY } from "../../constants/localStorageKeys";
import { DeviceSettings } from "./DeviceSettingsContext";

export async function getDeviceSettings(): Promise<DeviceSettings> {
    const trackBackgroundGeolocation = await Preferences.get({ key: BACKGROUND_GEOLOCATION_TRACKING_SETTING_KEY });
    return { trackBackgroundGeolocation: trackBackgroundGeolocation.value !== "false" }; // default should be true
}
